import React from "react";
import { CircleHelp } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export const GanttGuide = () => <Popover>
  <PopoverTrigger asChild><button type="button" className="gantt-chip" title="Guida al cronoprogramma" aria-label="Guida al cronoprogramma" data-testid="gantt-guide-trigger"><CircleHelp size={15} /></button></PopoverTrigger>
  <PopoverContent className="gantt-guide" side="bottom" align="end" data-testid="gantt-guide-content">
    <h3>Il cronoprogramma dello studio</h3>
    <p><strong>Filtri rapidi</strong> distinguono il lavoro dello studio, le attese esterne e i ritardi.</p>
    <p><strong>Filtri avanzati</strong> restringono per responsabile, tipologia, committente e anno.</p>
    <p><strong>Vedi tutte</strong> include anche le pratiche concluse e quelle fuori dalle priorità. I filtri selezionati restano attivi.</p>
    <p>I colori delle barre seguono lo stato; apri una pratica per confermare i passaggi economici.</p>
  </PopoverContent>
</Popover>;